import React from 'react';
import {identity} from 'lodash';

type CartMessageInputProps = Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> & {
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function CartMessageInput({onChange, ...props}: CartMessageInputProps) {
	const onChangeWrapper = React.useMemo(() => {
		if (!onChange) {
			return identity;
		}

		return (e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			if (value.length > 500) {
				return;
			}
			if (onChange) {
				onChange(e);
			}
		}
	}, [onChange]);

	return <input 
		{...props}
		type="text"
		className="form-control"
		onChange={onChangeWrapper}
	/>
}